import React, { useState } from 'react';
import { Row, Col, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import copy from 'copy-to-clipboard';

import SpanComponent from '@sharedComponent/span-component';

const TrackingStrings = ({ value = '', isAff = false }) => {
	const [visible, setvisible] = useState(false);
	const handleCopy = () => {
		setvisible(true);
		copy(value);
		setTimeout(() => {
			setvisible(false);
		}, 1000);
	};

	const col1 = isAff ? 5 : 6;
	const col2 = isAff ? 19 : 18;

	return isAff ? (
		<Row className="tracking_passed">
			{/* <Col xl={5} style={{ paddingRight: 20, marginBottom: 10 }}>
				<Col className="passed_value">
					<SpanComponent className="campaign_container_label">Passed Values</SpanComponent>
					<QuestionCircleOutlined />
				</Col>
			</Col> */}{' '}
			<Tooltip placement="top" title={'Click to copy the Tracking String'}>
				<Col xl={24} lg={20} md={24} sm={24} xs={24} onClick={handleCopy} style={{ cursor: 'pointer' }}>
					<Tooltip placement="top" color="#EB8601" visible={visible} title={'String copied'}>
						<div className="link_area">
							<div className="left_bor"></div>
							<SpanComponent>TrackingString :</SpanComponent>
							<div className="content">{value}</div>
						</div>
					</Tooltip>
				</Col>
			</Tooltip>
		</Row>
	) : (
		<Row className="tracking_passed">
			{/* <Col xl={6} style={{ paddingRight: 20, marginBottom: 10 }}>
				<Col className="passed_value">
					<SpanComponent className="campaign_container_label">Passed Values</SpanComponent>
					<QuestionCircleOutlined />
				</Col>
			</Col> */}
			<Tooltip placement="top" title={'Click to copy the Tracking String'}>
				<Col xl={24} lg={20} md={24} sm={24} xs={24} onClick={handleCopy} style={{ cursor: 'pointer' }}>
					<Tooltip placement="top" color="#EB8601" visible={visible} title={'String copied'}>
						<Row className="link_area">
							<div className="left_bor"></div>
							<Col xl={4}>
								<SpanComponent style={{ paddingRight: 5, fontSize: 12 }}>Tracking String:</SpanComponent>
							</Col>
							<Col xl={20} className="content">
								<span>{value}</span>
							</Col>
						</Row>
					</Tooltip>
				</Col>
			</Tooltip>
		</Row>
	);
};

export default TrackingStrings;
